import { useSmartRoutingSetupCompleteSellerSetting } from '../use-seller-setting';
import { useOrderRoutingFeatureGate } from '../../feature-gates/use-order-routing-feature-gate';

export const useShouldDisplayAutoRoutingControls = () => {
  const isSmartRoutingSetupComplete = useSmartRoutingSetupCompleteSellerSetting();
  const isOrderRoutingEnabled = useOrderRoutingFeatureGate();

  return isOrderRoutingEnabled && isSmartRoutingSetupComplete;
};
